import mixpanel from 'mixpanel-browser';

const TOKEN = import.meta.env.VITE_MIXPANEL_API_KEY || '';

export enum CalculatorUsedEvent {
  CurrencyCalculatorValueAdded = 'Currency Calculator Value Added',
  CurrencyCalculatorSliderUsed = 'Currency Calculator Slider Used',
}

export enum SignupEvent {
  ClickedSignupButton = 'Clicked Signup Button',
}

export enum RequestDemoEvent {
  RequestedDemo = 'Requested Demo',
}

export enum NavigationClick {
  ClickedLoginButton = 'Clicked Login Button',
  ClickedSignUpButton = 'Clicked SignUp Button',
}

export enum SwiftCodeFinderUsedEvent{
  SelectedCountry = 'Swift Code Finder Country Selected',
  SelectedCity = 'Swift Code Finder City Selected',
  SelectedBank = 'Swift Code Finder Bank Selected'
}

export enum HSCodeFinderUsedEvent{
  SelectedHSCode = 'HS Code Finder HS Code Selected',
  SelectedDescription = 'HS Code Finder Description Selected'
}

export interface CalculatorEventPropsType {
  page: string;
  currency: string;
  value: number;
}

export interface SignupEventPropsType {
  page: string;
  section: string;
}

export interface RequestDemoEventPropsType {
  page: string;
  companyName: string;
  email: string;
}

export interface NavigationPropsType {
  section: string;
  page: string;
}

export interface SwiftCodeFinderUsedEvenetPropsType {
  country: string;
  city: string;
  bank: string;
}

export interface HSCodeFinderUsedEventPropsType {
  hscode: string;
  description: string;
}

export function initAnalytics() {
  mixpanel.init(TOKEN, {
    debug: false,
    record_sessions_percent: import.meta.env.DEV ? 0 : 100,
    secure_cookie: true,
  });
}

export function trackCalculatorEvent(event: CalculatorUsedEvent, props: CalculatorEventPropsType) {
  mixpanel.track(event, props);
}

export function trackSignupEvent( props: SignupEventPropsType) {
  mixpanel.track(SignupEvent.ClickedSignupButton, props);
}

export function trackRequestDemoEvent(props: RequestDemoEventPropsType) {
  mixpanel.track(RequestDemoEvent.RequestedDemo, props);
}

export function trackNavigationEvent(event: NavigationClick, props: NavigationPropsType ){
  mixpanel.track(event, props);
}

export function trackPageView(pageName: string) {
  const eventName = `Landed On ${pageName} Page`;
  mixpanel.track(eventName);
}

export function tractSwiftCodeFinderUsedEvent(event: SwiftCodeFinderUsedEvent, props: SwiftCodeFinderUsedEvenetPropsType) {
  mixpanel.track(event, props);
}

export function trackHSCodeFinderUsedEvent(event: HSCodeFinderUsedEvent, props: HSCodeFinderUsedEventPropsType) {
  mixpanel.track(event, props);
}